var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"testiframe",staticStyle:{"width":"-webkit-fill-available","height":"500px"},attrs:{"src":_vm.iframeUrlWithToken,"title":"cobrowse"}})}
var staticRenderFns = []

export { render, staticRenderFns }